import { CModal, CModalHeader, CModalBody, CModalFooter } from "@coreui/react";
import "../SmartModal.css";
import PositionDataOverride from "../data_override/position_data_override";

const PositionUpdateModal = ({ visible, call_on_close, position }) => {
    return (
        <>
            {visible && (
                <div>
                    <CModal visible={visible} onClose={() => call_on_close()}>
                        <CModalHeader onClose={() => call_on_close()}>
                            <p>Position Price Override</p>
                        </CModalHeader>
                        <CModalBody>
                            <PositionDataOverride
                                position={position}
                                all_accounts={[position.account]}
                            />
                        </CModalBody>
                        <CModalFooter>
                            <button
                                className="ram_button"
                                onClick={() => call_on_close()}
                            >
                                Close
                            </button>
                        </CModalFooter>
                    </CModal>
                </div>
            )}
        </>
    );
};

export default PositionUpdateModal;
